import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
const Config: AppConfig = getAppConfig();

export const API_ENDPOINTS = {
  CUSTOMER_EXIST_OTP: `${Config.wag_url}/customer/onboarding/exist_otp`,
  CUSTOMER_CHECK_EXISTS: `${Config.wag_url}/customer/exists`,
  CUSTOMER_SIGNUP: `${Config.wag_url}/customer/onboarding/signup`,
  CUSTOMER_VALIDATE_OTP: `${Config.wag_url}/customer/onboarding/validation`,
  CUSTOMER_RESEND_SMS_OTP: `${Config.wag_url}/customer/onboarding/resend_otp`,
  CUSTOMER_RESEND_WHATSAPP_OTP: `${Config.wag_url}/customer/onboarding/resend_otp/whatsapp`,
  CUSTOMER_LOGOUT: `${Config.wag_url}/customer/onboarding/logout`,
  CUSTOMER_PROFILE: `${Config.wag_url}/customer/profile`,
};
